import SurveyQuestionCard from "./SurveyQuestionCard";

// Renders the ordered list of question/section/instruction cards. Items are
// appended via SurveyComponentPalette (the left column) — this component
// only handles editing, reordering, and removing what's already there.
const SurveyQuestionBuilder = ({ questions, error, onChange }) => {
  const updateQuestion = (id, patch) => {
    onChange(questions.map((q) => (q.id === id ? { ...q, ...patch } : q)));
  };

  const removeQuestion = (id) => {
    onChange(questions.filter((q) => q.id !== id));
  };

  const moveQuestion = (index, direction) => {
    const target = index + direction;
    if (target < 0 || target >= questions.length) return;
    const next = [...questions];
    [next[index], next[target]] = [next[target], next[index]];
    onChange(next);
  };

  return (
    <>
      <div className="survey-questions-header">
        <h4>Questions</h4>
        {error && <span className="error">{error}</span>}
      </div>

      {questions.length === 0 && (
        <p className="survey-builder-empty-hint">No components added yet — click a component on the left to get started.</p>
      )}

      {questions.map((question, index) => (
        <SurveyQuestionCard
          key={question.id}
          question={question}
          index={index}
          isFirst={index === 0}
          isLast={index === questions.length - 1}
          onUpdate={updateQuestion}
          onRemove={removeQuestion}
          onMove={moveQuestion}
        />
      ))}
    </>
  );
};

export default SurveyQuestionBuilder;
